import React,{useContext, useState} from "react"
import {Modal} from "reactstrap"
import "../../assets/scss/manual/manual.scss";
import { AuthContext } from "context/authContext";
import axios from "axios";
import AppConfig from "../../constants/config";
import toast from 'react-hot-toast';

const DeleteTemplate = (prop) => {
	const { mode } = useContext(AuthContext);
    const {deleteOpen, toggleDelete, setDeleteOpen, getGlData, glgroup, setSelectedGroup } = prop;
    const [loading, setLoading] = useState(false);


    const handleSubmit = async(e) => {
        setLoading(true)
        try {
            e.preventDefault();
            const {data} = await axios.post(`${AppConfig.baseUrl}/gl_template/delete_gl_template`, {id: glgroup._id, mode: mode || 'lessee'},{
                headers:{token: localStorage.getItem('token')}
            });
            if(!data.error){
                toast.success("G/L template deleted successfully");
                getGlData();
                setSelectedGroup({})
                setDeleteOpen(false);
            }
            else{
                throw new Error(data.title);
            }
        } catch (error) {
            setSelectedGroup({})
            setDeleteOpen(false);
            toast.error(error.message || 'Something went wrong');
        }
        setLoading(false)
    }

    return (
        <Modal
            isOpen={deleteOpen}
            toggle={() => {
                toggleDelete();
            }}
            centered
        >
            <div className="modal-header">
                <h5 className="modal-title mt-0">Delete G/L template</h5>
                <button
                    type="button"
                    onClick={()=>{
                        setSelectedGroup({})
                        setDeleteOpen(false);
                    }}
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="modal-body">
                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        Are you sure you want to delete this G/L template ?
                    </div>
                    <div className="modal-footer mt-3">
                        <button
                            type="button"
                            className="btn btn-lbusers"
                            onClick={()=>{
                                setSelectedGroup({})
                                setDeleteOpen(false);
                            }}
                            disabled={loading} 
                        >
                            {
                                loading && <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i> 
                            }
                            No
                        </button>
                        <button type="submit" className="btn btn-lbusers" disabled={loading} >
                            {
                                loading && <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i> 
                            }
                            Yes
                        </button>
                    </div>
                </form>
            </div>
        </Modal>
    )
}

export default DeleteTemplate